import CookiePreferencesPage from './CookiePreferencesPage';
import PrivacyPolicy from './PrivacyPolicy';
import TermsAndConditions from './TermsAndConditions';

export const LEGAL_INFORMATION_CENTER_ROUTES = [
  {
    label: 'Customer and User Terms and Conditions',
    pathname: 'terms-and-conditions',
    component: TermsAndConditions,
  },
  {
    label: 'Privacy Policy',
    pathname: 'privacy-policy',
    component: PrivacyPolicy,
  },
  {
    label: 'Preferences',
    pathname: 'cookie-preferences',
    component: CookiePreferencesPage,
  },
];
